import * as React from 'react'

const CloseIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 18 18 6M6 6l12 12"
      stroke={props.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

CloseIcon.defaultProps = {
  height: 24,
  width: 24,
  stroke: '#475569'
}

export { CloseIcon }
